(function () {
  var finePointer = window.matchMedia("(pointer: fine)");
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var resetTimers = new WeakMap();

  function cardFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    var figure = target.closest(".product-card__figure");
    if (!figure) return null;
    var video = figure.querySelector(".product-card__hover-video");
    if (!video) return null;
    return { figure: figure, video: video };
  }

  function stillInside(figure, event) {
    return event.relatedTarget && figure.contains(event.relatedTarget);
  }

  function holdLastFrame(video) {
    var holdAt = video.duration - 0.05;
    if (!Number.isFinite(holdAt) || holdAt < 0) return;
    try {
      video.currentTime = holdAt;
    } catch (error) {}
  }

  document.addEventListener("pointerover", function (event) {
    if (!finePointer.matches || reduceMotion.matches) return;
    var card = cardFromEvent(event);
    if (!card || stillInside(card.figure, event)) return;

    var pendingReset = resetTimers.get(card.video);
    if (pendingReset) window.clearTimeout(pendingReset);

    card.video.muted = true;
    card.video.defaultMuted = true;
    card.video.playsInline = true;
    try {
      card.video.currentTime = 0;
    } catch (error) {}

    var playAttempt = card.video.play();
    if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
  });

  document.addEventListener("pointerout", function (event) {
    var card = cardFromEvent(event);
    if (!card || stillInside(card.figure, event)) return;

    card.figure.classList.remove("is-hover-video-playing");
    card.video.pause();

    var pendingReset = resetTimers.get(card.video);
    if (pendingReset) window.clearTimeout(pendingReset);
    resetTimers.set(card.video, window.setTimeout(function () {
      if (card.figure.matches(":hover")) return;
      try {
        card.video.currentTime = 0;
      } catch (error) {}
    }, 180));
  });

  document.addEventListener("playing", function (event) {
    var video = event.target;
    if (!video || !video.classList || !video.classList.contains("product-card__hover-video")) return;
    var figure = video.closest(".product-card__figure");
    if (!figure || !figure.matches(":hover")) {
      video.pause();
      return;
    }
    figure.classList.add("is-hover-video-playing");
  }, true);

  document.addEventListener("ended", function (event) {
    var video = event.target;
    if (!video || !video.classList || !video.classList.contains("product-card__hover-video")) return;
    holdLastFrame(video);
  }, true);
})();
